import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./Services/redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
import Notification from "./Services/Notification";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // <Provider store={store}>
  //   <App />
  // </Provider>,
  <GoogleOAuthProvider clientId="52268706031-26qf983rr9rv4nq2003al7qdokc5if32.apps.googleusercontent.com">
      <Provider store={store}>
        <BrowserRouter>
          <App />
          <Notification />
        </BrowserRouter>
      </Provider>
  </GoogleOAuthProvider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
